<template>
  <div class="bgacommissionsearch">
    <div v-cloak>
      <b-alert
          :show="showAlert"
          variant="danger"
      >
        {{ error }}
      </b-alert>
      <template v-if="authorized">

        <bga-terms-of-use></bga-terms-of-use>

        <b-form ref="commission" class="searchFields" @submit.prevent="updateData">

          <div class="accordion" role="tablist">

            <cm-card card-title="Carriers to include in search"
                     toggle="accordion-carriers">
              <b-form-checkbox
                  v-model="selectAllCarriers"
                  :indeterminate="indeterminateCarriers"
                  @change="select('selectedCarriers', selectAllCarriers, carriers, 'id', 'indeterminateCarriers')"
              >
                {{ selectAllCarriers ? 'Unselect All' : 'Select All' }}
              </b-form-checkbox>
              <b-form-checkbox
                  v-for="carrier in carriers"
                  :key="carrier.id"
                  v-model="selectedCarriers"
                  :value="carrier.id"
              >
                <span v-html="carrier.name"></span>
              </b-form-checkbox>

            </cm-card>

            <cm-card card-title="Product Category" toggle="accordion-prodCategory">

              <b-form-group>
                <b-form-select
                  v-model="selectedProdCat"
                  :options="productCategories"
                  class="mt-3"
                  name="prodCategory" size="sm"></b-form-select>
              </b-form-group>

            </cm-card>

            <cm-card v-if="selectedProdCat !== 'Select One' && selectedProdCat !== 'Disability' && selectedProdCat !== 'Health' && selectedProdCat !== ''" card-title="Product Type" toggle="accordion-prodType">

              <b-form-group>
                <b-form-select
                  v-model="selectedProdType"
                  :options="prodTypes"
                  class="mt-3"
                  name="prodType" size="sm"></b-form-select>
              </b-form-group>

            </cm-card>

            <cm-card v-if="showLifeSurvivor && selectedProdCat !== 'Select One' && selectedProdCat !== ''" card-title="Single Life or Survivor" toggle="accordion-lifeOrSurvivor">
              <b-form-radio-group
                  name="lifeOrSurvivor"
                  stacked
                  v-model="selectedLifeSurvivor"
                  @change="criteriaChanged = true"
              >
                <b-form-radio value="No Preference">No Preference</b-form-radio>
                <b-form-radio value="Single Life">Single Life</b-form-radio>
                <b-form-radio value="Survivor">Survivor</b-form-radio>
              </b-form-radio-group>

            </cm-card>

            <cm-card v-if="selectedProdCat !== 'Select One' && selectedProdCat !== ''" card-title="Issue Age" toggle="accordion-useIssueAge">
              <b-form-radio-group
                  name="useIssueAge"
                  stacked
                  v-model="selectedIssueAge"
                  @change="handleIssueAgeSelection($event)"
              >
                <b-form-radio :value=false>No Preference</b-form-radio>
                <b-form-radio :value=true>Only show products that support this issue age:</b-form-radio><b-form-input v-model="prodIssueAge" name="issueAge" :disabled="!selectedIssueAge" type="text" pattern="\d*" maxlength="3"></b-form-input>
              </b-form-radio-group>

            </cm-card>

            <cm-card v-if="selectedProdCat !== 'Select One' && selectedProdCat !== ''" card-title="Street Level Minimum" toggle="accordion-showOnlyStreetLevel">
              <b-form-radio-group
                  name="showOnlyStreetLevel"
                  stacked
                  v-model="selectedStreetLevel"
                  @change="handleStreetLevelSelection($event)"
              >
                <b-form-radio :value=false>No Preference</b-form-radio>
                <b-form-radio :value=true>Only show products for which the Street Level >=</b-form-radio>
                <b-form-input
                  type="text"
                  v-model="formattedStreetLevel"
                  name="formattedStreetLevel"
                  @input.native="formatCurrency($event)"
                  @blur.native="formatCurrency($event)"
                  :disabled="!selectedStreetLevel"
                  maxlength="7">
                </b-form-input>
              </b-form-radio-group>

            </cm-card>

            <b-form-checkbox
                v-if="selectedProdCat !== 'Select One' && selectedProdCat !== ''"
                name="showOnlyBonus"
                switch
                v-model="selectedShowOnlyBonus"
                @change="criteriaChanged = true">
                Only show products with a Bonus
              </b-form-checkbox>
              <b-form-checkbox
                v-if="selectedProdCat !== 'Select One' && selectedProdCat !== ''"
                name="showOnlyVerified"
                switch
                v-model="selectedShowOnlyVerified"
                @change="criteriaChanged = true">
                Only show Products verified in the last 18 months
              </b-form-checkbox>


            <div class="d-flex justify-content-between align-items-center">
              <div class="d-flex align-items-center">
                <b-button variant="success" v-on:click="updateData">{{this.buttonText}}</b-button>
                <b-button class="ml-2 btn-clear" variant="light" @click="clearSearch(true)" v-if="items.length > 0">Clear</b-button>
              </div>
              <img style="width:120px" src="https://carriermatrix.com/wp-content/uploads/Engineered-By-Simplicity.jpg"  alt="Engineered By Simplicity Group">
            </div>



          </div>
        </b-form>

      </template>
    </div>
  </div>
</template>

<script>
import {bus} from "@/event-bus";
import HelperFunctions from "@/mixins/helper-functions"
export default {
  name: "BGACommissionSearch",
  mixins: [HelperFunctions],
  props: {},
  data() {
    return {
      items: [],
      error: '',
      query_args: '',
      showAlert: false,
      selectedProdCat: 'Select One',
      dontPreselectCarriers: true,
      productCategories: [
        'Select One',
        'Annuity',
        'Life',
        'Long-Term Care',
        'Disability',
        'Health',
      ],
      selectedProdType: '',
      prodTypes: [],
      prodTypesPerCategory: {
        "Annuity": [
          'Select One',
          'FA - Fixed Annuity',
          'FIA - Fixed Index Annuity',
          'MYGA - Multi-Year Guaranteed Annuity',
          'DIA - Deferred Income Annuity',
          'SPIA - Single Premium Immediate Annuity',
          'RILA - Registered Index-Linked Annuity',
          'VA - Variable Annuity',
          'Other',
        ],
        "Life": [
          'Select One',
          'Term',
          'WL - Whole Life',
          'CAUL - Current Assumption Universal Life',
          'IUL - Indexed Universal Life',
          'GUL - Guaranteed Universal Life',
          'VUL - Variable Universal Life',
          'SPL - Single Premium Life',
          'Accidental Death',
          'Final Expense',
          'Failure to Survive',
        ],
        "Long-Term Care": [
          'Select One',
          'Traditional Long-Term Care',
          'Asset-Based Long-Term Care',
        ],
        "Disability": [
        ],
        "Health": [
        ],
      },
      showLifeSurvivor: false,
      showLifeOrSurvivorFor: [
          "Term",
          "WL - Whole Life",
          "CAUL - Current Assumption Universal Life",
          "IUL - Indexed Universal Life",
          "GUL - Guaranteed Universal Life",
          "VUL - Variable Universal Life",
          "SPL - Single Premium Life",
      ],
      selectedLifeSurvivor: 'No Preference',
      selectedIssueAge: false,
      prodIssueAge: 30,
      selectedStreetLevel: false,
      streetLevelPercentage: 0.00,
      selectedShowOnlyBonus: false,
      selectedShowOnlyVerified: true,
      formattedStreetLevel: "0.00%",
      showClearButton: false,
    }
  },
  mounted() {

    this.fetchCarriers().catch(error => {
      console.error(error)
    })
  },
  computed: {
  },
  methods: {
    formatCurrency(e) {
      let int = e.target.value.slice(0, e.target.value.length - 1);

      if (int.includes('%')) {
        e.target.value = '%';
      } else if (int == '1000') {
        e.target.value = int + '%';
        e.target.setSelectionRange(5, 5);
      } else if (int.length >= 4 && int.length <= 5 && !int.includes('.')) {
        e.target.value = int.slice(0, 3) + '.' + int.slice(3, 4) + '%';
        e.target.setSelectionRange(5, 5);
      } else if (int.length >= 6 && int.length <= 7) {
        let whole = int.slice(0, 3);
        let fraction = int.slice(4, 6);
        e.target.value = whole + '.' + fraction + '%';
      } else {
        e.target.value = int + '%';
        e.target.setSelectionRange(e.target.value.length - 1, e.target.value.length - 1);
      }
    },
    updateResults() {
      bus.$emit("update-commission-results-items", this.items)
    },

    clearSearch(clearType = false) {

      this.items = []
      bus.$emit("update-commission-results-items", this.items)

      this.selectAllCarriers           = false
      this.indeterminateCarriers       = false
      this.selectedCarriers            = []
      this.prodTypes                   = []
      this.selectedProdCat             = 'Select One'
      this.selectedProdType            = ''
      this.showLifeSurvivor            = false
      this.selectedLifeSurvivor        = 'No Preference'
      this.selectedIssueAge            = false
      this.prodIssueAge                = 30
      this.selectedStreetLevel         = false
      this.streetLevelPercentage       = 0.00
      this.formattedStreetLevel        = "0.00%"
      this.selectedShowOnlyBonus       = false
      this.selectedShowOnlyVerified    = true
      this.criteriaChanged             = false
      this.showClearButton             = false
      this.items                       = []
      this.error                       = ''
      this.query_args                  = ''
      this.showAlert                   = false
    },

    async updateData() {
      this.items = []
      this.updateResults()
      this.showClearButton = true
      if (!this.selectedCarriers.length) {
        this.showAlert = true
        this.error = 'At least one Carrier needs to be selected'
        this.scrollToTop()
        return
      }
      this.items = []
      const formData = new FormData(this.$refs['commission'])
      formData.append('per_page', 99)
      formData.append('selectedCarriers', this.selectedCarriers)
      formData.append('api_key', this.apiKey)
      formData.append('site', window.location.href)
      const data = {}
      for (let [key, val] of formData.entries()) {
        Object.assign(data, {[key]: val})
      }
      const params = new URLSearchParams(data)
      const options = {
        headers: new Headers(),
      }
      this.items = await fetch(this.$hostname + '/cm_api/cm/v1/commission-api?' + params, options)
          .then(res => {
            return res.json()
          })
          .then(items => items)

      if (this.items.error) {
        this.showAlert = true
        this.error = this.items.error.message
        this.query_args = this.items.error.query_args
        this.scrollToTop()
      }

      if (this.items.length === 0) {
        this.showAlert = true
        this.error = 'No Products Found'
        this.scrollToTop()
      }

      this.updateResults()

    },
    formatInput() {
      if (isNaN(this.streetLevelPercentage)) {
        this.streetLevelPercentage = 0.00;
      } else {
        this.streetLevelPercentage = parseFloat(this.streetLevelPercentage).toFixed(2);
      }
    },
  },
  watch: {
    selectedProdCat(newCat, oldCat) {
      if (newCat == "Select One") { return false; }
      if (this.prodTypesPerCategory[newCat].length > 0) {
        this.selectedProdType = "Select One"
        this.prodTypes = this.prodTypesPerCategory[newCat]
      }
    },
    selectedProdType(newType, oldType) {
      this.showLifeSurvivor = this.showLifeOrSurvivorFor.includes(newType)
    }
  }
};
</script>

<!-- Add "scoped" attribute to limit CSS to this component only only -->
<style scoped>
.cm-terms-of-use,
.searchFields {
  max-width: 700px;
}
.searchFields select,
.searchFields input {
  max-width: 300px;
}
.carrier-matrix .btn-light.btn-clear:hover {
    background-color: #E2E6EA;
}
</style>
